// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MeQa","tabsBox":"styles_tabsBox__7irHP","createButton":"styles_createButton__17SzC"};